import classNames from 'classnames';
import React from 'react';
import { Indicators } from '../indicators';
import { Name } from '../name';
import { useVideoConfig } from '../../../video-config-provider';
import s from './content.scss';
export const Content = ({ children, className, attendeeId, hideIndicators, focused, }) => {
    const { dashboard } = useVideoConfig();
    return (React.createElement("div", { className: classNames(s.container, className, { [s.dashboardContainer]: dashboard }) },
        children,
        React.createElement(Name, { focused: focused, attendeeId: attendeeId }),
        !hideIndicators && React.createElement(Indicators, { attendeeId: attendeeId })));
};
//# sourceMappingURL=content.js.map